<app-bread-crumb-options *ngIf="!isExternalPage"></app-bread-crumb-options>
<div class="container">
    <div *ngIf="showIntroductoryPage" class="pt-5">
        <div class="sub-txt-big pt-1 pb-5 pt-5">
            <h2 class="text-center"> Welcome!</h2>
            <br>
            <div class="row mt-3 padding-left-15pct margin-btm-5-pct">
                <div class="font-18 text-break">You are about to begin the Risk Tolerance Questionnaire. The questionnaire must be completed in one session. <br/>
                    If you exit the session before you complete the questionnaire, you will be required to restart from the beginning.
                </div>
            </div>
        </div>
    </div>
    <div class="row mx-5 margin-top-btm-3-pct" *ngIf="!showIntroductoryPage">
        <div class="col-md-12 col-sm-6 col-xs-12 my-4">
            <div class="color-purple font-weight-600 font-20 mb-3 d-inline-block">Question {{questionNumber}} of {{questionList.length}}</div>
                <sup><i class="fa fa-question-circle cursor-pointer ps-1 font-14" *ngIf="questionList[questionNumber-1].tooltip_text"
                aria-hidden="true"
                tooltipClass="tooltipBigData tooltipHtml" [ngbTooltip]="questionList[questionNumber-1].tooltip_text" placement="top"
                triggers="mouseenter:mouseleave" container="body"></i></sup>
            <br>
            <div class="text-start font-24 line-height-1pt3 font-weight-300 mb-3">
                {{questionList[questionNumber-1].description}} {{questionList[questionNumber-1].content}}</div>
            <!-- Button bar -->
            <div class="d-flex flex-wrap col-sm-12 col-xs-12 px-0" *ngIf="questionList[questionNumber-1].question_type == 'Buttons'">
                <div class="d-inline-block ms-0 me-3 my-2 position-relative"
                    *ngFor="let option of questionList[questionNumber-1].investor_profile_answers; let i = index">
                    <button [disabled]="option.disabled" class="btn btn-md btn-default font-15 color-333 ques-button-inr"
                        [ngClass]="option.selected?'selected':''"
                        (click)="getSelectedAnswer(option)"
                        [attr.data-testid]="'get-started.risk-tolerance.answer-btn-' + i">{{option.description}}
                        <span class="tick1" [ngClass]="option.selected?'selected':''"><i class="fa fa-check" aria-hidden="true"></i></span></button>
                </div>
            </div>
            <!-- Block -->
            <div class="d-flex flex-wrap mt-5 col-sm-12 col-xs-12 px-0"
                *ngIf="questionList[questionNumber-1].question_type == 'Blocks'">
                <div class="ques-block-inr ques-block-inr-width cursor-pointer ques-block-inr-border ms-0 me-3" (click)="getSelectedAnswer(option)"
                    [ngClass]="{divdisabled: option.disabled, selected: option.selected}"
                    *ngFor="let option of questionList[questionNumber-1].investor_profile_answers; let i = index"
                    [attr.data-testid]="'get-started.risk-tolerance.block-answer-' + i"
                    role="button"
                    [attr.aria-label]="option.title || option.description">
                    <div [hidden]="!option.title" class="text-center font-16 fw-bold">{{option.title}}</div>
                    <div class="desc font-15 color-333">{{option.description}}</div>
                    <span class="tick1" [ngClass]="option.selected?'selected':''"><i class="fa fa-check" aria-hidden="true"></i></span>
                </div>
            </div>
            <!-- Image Block-->
            <div class="ques-block-display-flex flex-wrap mt-5 col-sm-12 col-xs-12 px-0"
                *ngIf="questionList[questionNumber-1].question_type == 'Images'">
                <div class="ques-block-inr ques-block-inr-width-25 cursor-pointer ques-block-inr-border ms-0 me-3"
                [ngClass]="{divdisabled: option.disabled, selected: option.selected}"
                    (click)="getSelectedAnswer(option)" [ngClass]="option.selected? 'selected': ''"
                    *ngFor="let option of questionList[questionNumber-1].investor_profile_answers; let i = index"
                    [attr.data-testid]="'get-started.risk-tolerance.image-answer-' + i"
                    role="button"
                    [attr.aria-label]="option.title || option.description">
                    <div [hidden]="!option.title" class="text-center font-16 fw-bold">{{option.title}}</div>
                    <div class="question-img-padding"><img src="{{option.image.url}}" class="question-img question-img-size" [attr.alt]="option.title || option.description"></div>
                    <span class="tick1" [ngClass]="option.selected? 'selected': ''"><i class="fa fa-check" aria-hidden="true"></i></span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="rtqEmail == 'true'">
        <app-buttonbar *ngIf="questionNumber>1" (clickedprev)="gotoPreviousState()" hidenextbtn="true"></app-buttonbar>
    </div>
    <div *ngIf="rtqEmail == null">
        <app-buttonbar (clickedprev)="gotoPreviousState()" hidenextbtn="true"></app-buttonbar>
    </div>
    <div *ngIf="showIntroductoryPage" class="text-center">
        <button class="btn btn-primary rounded-pill btn-lg-custom my-2 mx-4" [ngClass]="{'disabledBtn pointer-events-none': disableGetStartedBtn}" (click)="gotoQuestion(1)" [disabled]="disableGetStartedBtn"
            data-testid="get-started.risk-tolerance.lets-go-btn">
            Let's go!<i class="fa fa-long-arrow-right ms-3 align-middle font-24" aria-hidden="true"></i>
        </button>
    </div>
</div>
